// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"b9e81e80","254":"4660eb8c","474":"7f033b70","830":"09db758d","903":"050ad5f7"}[chunkId] + ".chunk.js";
};